<template>
  <v-container fluid class="help">
    <v-row>
      <v-col class="text-center">
      <h1>Memo</h1>
      <br><br>
      
      <v-expansion-panels focusable>
        <v-expansion-panel
          v-for="memoYear in memoData"
          :key="memoYear.title"
        >
          <v-expansion-panel-header>{{memoYear.title}}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="px-4">
            <v-col
              v-for="a in memoYear.list"
              :key="a.code"
              class="d-flex child-flex"
              cols="12"
              sm="3"
            >
              <v-card class="d-flex flex-column">
                
                <v-card-subtitle>{{a.displayDate}}</v-card-subtitle>
                <v-card-text>{{a.subject}}</v-card-text>
                <v-spacer></v-spacer>
                <v-card-actions class="justify-center">
                  
                  <v-btn
                    small
                    text
                    outlined
                    color="primary"
                    @click="viewInDialog(a.link, a.subject)"
                  >
                    View
                  </v-btn>
                </v-card-actions>
                
              </v-card>
              <br>
            </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-dialog
        v-model="dialog"
        width="auto"
        fullscreen
        :scrim="false"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-toolbar-title>
              <template v-if="isLoading"> Loading... </template>

              <template v-else>
                {{title}}
              </template>

            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                small
                :href="link"
                target="_blank"
              >
                Download
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                small
                color="error"
                variant="text"
                @click="closeDialog()"
              >
                X 
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          
          <vue-pdf-embed 
            :source="link"
            @rendered="handleDocRender"
            @progress="handleDocProgress"
            @loading-failed="handleLoadingFailed"
          />
          
        </v-card>
      </v-dialog>
      
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  components: {
    VuePdfEmbed,
  },
  data: () => ({
    dialog: false,
    link: '',
    title: '',
    isLoading: true,
    isErrorLoading: false,

    memoData: [
      { 
        title: '2023',
        
        list: [
          {
            date: '2023-11-22',
            displayDate: '22 Nov 2023',
            code: 'MKA/TL/PA/005/23',
            subject: 'STRUKTUR “OVERIDING COMMISSION” PELAN PROSECURE UNTUK CHIEF ADVISOR',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/11/MKA-TL-PA-005-23.pdf', 
          },
          {
            date: '2023-7-31',
            displayDate: '31 Julai 2023',
            code: 'MKA/TL/PA/004/23',
            subject: 'STRUKTUR “OVERIDING COMMISSION” PELAN ORDINARY TAKAFUL UNTUK CHIEF ADVISOR',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/08/MKA-TL-PA-004-23.pdf', 
          },
          {
            date: '2023-3-23',
            displayDate: '23 Mac 2023',
            code: 'NAM/MHMT/TL/C021/23',
            subject: 'MEMO WAKTU OPERASI PEJABAT PADA BULAN RAMADHAN',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/03/NAM-MHMT-TL-C021-23.pdf', 
          },
          {
            date: '2023-1-14',
            displayDate: '14 Jan 2023',
            code: 'MKA/TL/PA/003/23-01',
            subject: 'TRUST SUCCESS MODULES 2023',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/01/TRUST-SUCCESS-MODULES-2023.pdf', 
          },
          {
            date: '2023-1-9',
            displayDate: '9 Jan 2023',
            code: 'TRUST-HANDBOOK',
            subject: 'TRUST HANDBOOK',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/01/TRUST-HANDBOOK-2023.pdf', 
          },
          {
            date: '2023-1-9',
            displayDate: '9 Jan 2023',
            code: 'MKA/TL/PA/001/23',
            subject: 'GUIDELINES FOR AGENCY MAINTENANCE QUOTA AND PROMOTION',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/01/MKA-TL-PA-001-23.pdf', 
          },
          {
            date: '2023-1-9',
            displayDate: '9 Jan 2023',
            code: 'MKA/TL/PA/002/23',
            subject: 'MEMO FOR ZURICH FRANCHISE NETWORK (ZFN) SYSTEMS FEES',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/01/MKA-TL-PA-002-23.pdf', 
          },
          {
            date: '2023-1-9',
            displayDate: '9 Jan 2023',
            code: 'MKA/TL/PA/003/23',
            subject: 'STRUKTUR “OVERIDING COMMISSION” PELAN RIDER MEDIAFYA UNTUK CHIEF ADVISOR',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/01/MKA-TL-PA-003-23.pdf', 
          },
          {
            date: '2023-1-4',
            displayDate: '4 Jan 2023',
            code: 'JO/TL/PA/002/23',
            subject: 'CEO SPEED CHALLENGE - BANGKOK 2023',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/04/JOTLPA00223-Memo-CEO-Speed-Challenge-Bangkok-2023-1.pdf', 
          },
          {
            date: '2023-1-1',
            displayDate: '1 Jan 2023',
            code: 'JO/TL/PA/001/23',
            subject: 'KOD & ETIKA EJEN DI BAWAH TERAS LEGACY SDN BHD',
            link: 'https://teraslegacy.com/wp-content/uploads/2023/01/JO-TL-PA-001-23.pdf', 
          },
        ], 
      },
      { 
        title: '2022',
        list: [
          {
            date: '2022-12-3',
            displayDate: '3 Disember 2022',
            code: 'JO/TL/PA/012/22',
            subject: 'TERAS IDEAS CONVENTION 2023 – POTONGAN KOMISEN UNTUK EXECUTIVE ADVISOR',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/12/JOTLPA01222-Teras-Ideas-Convention-2023.pdf'
          },
          {
            date: '2022-7-8',
            displayDate: '8 Julai 2022',
            code: 'MKA-TL-PA-006-22',
            subject: 'IDEAS POD TERAS LEGACY',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/07/MKA-TL-PA-006-22.pdf'
          },
          {
            date: '2022-6-12',
            displayDate: '12 Jun 2022',
            code: 'MKA-TL-PA-005-22',
            subject: 'AWARENESS BEFORE CHANGE (ABC) CAMP',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/06/MKA-TL-PA-005-22.pdf'
          },
          {
            date: '2022-6-6',
            displayDate: '6 Jun 2022',
            code: 'MKA-TL-PA-004-22',
            subject: 'MESYUARAT MINGGUAN AMS DAN MESYUARAT AGENSI',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/06/MKA-TL-PA-004-22.pdf'
          },
          {
            date: '2022-4-1',
            displayDate: '1 April 2022',
            code: 'NAM-MHMT-TL-C001-22',
            subject: 'MEMO WAKTU OPERASI PEJABAT PADA BULAN RAMADHAN',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/04/NAM-MHMT-TL-C001-22.pdf' 
          },
          {
            date: '2022-2-14',
            displayDate: '14 Feb 2022',
            code: 'JO-TL-PA-005-22',
            subject: 'PENAMBAHBAIKAN KONTRAK CHIEF ADVISOR(CA) BAGI TAHUN 2022',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/02/JO-TL-PA-005-22.pdf', 
          },
          {
            date: '2022-2-14',
            displayDate: '14 Feb 2022',
            code: 'MKA-TL-PA-003-22',
            subject: 'PEMANTAPAN STRUKTUR "OVERIDING COMMISSION" UNTUK CHIEF ADVISOR',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/02/MKA-TL-PA-003-22.pdf', 
          },
          {
            date: '2022-1-10',
            displayDate: '10 Jan 2022',
            code: 'JO-TL-PA-004-22',
            subject: 'PENILAIAN PRESTASI UNTUK CHIEF ADVISOR (CA) YANG DILANTIK MELALUI KEMPEN TLP 2.0',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/JO-TL-PA-004-22.pdf', 
          },
          {
            date: '2022-1-7',
            displayDate: '7 Jan 2022',
            code: 'JO-TL-PA-003-22',
            subject: 'TLP CAMPAIGN 3.0',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/JO-TL-PA-003-22.pdf', 
          },
          {
            date: '2022-1-3',
            displayDate: '3 Jan 2022',
            code: 'NAM-MHMK-TL-PA-001-22',
            subject: 'SEKATAN OVERRIDING COMMISSION (OR) BULAN DISEMBER 2021',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMK-TL-PA-001-22.pdf', 
          },
          {
            date: '2022-1-1',
            displayDate: '1 Jan 2022',
            code: 'MKA-TL-PA-002-22',
            subject: 'TRUST SUCCESS PROGRAMME 2022',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-002-22.pdf', 
          },
        ], 
      },
      { 
        title: '2021',
        list: [
          {
            date: '2021-12-2',
            displayDate: '2 Dec 2021',
            code: 'NAM-MHMK-TL-PA-014-21',
            subject: 'SEKATAN OVERRIDING COMMISSION (OR) BULAN NOVEMBER 2021',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMK-TL-PA-014-21.pdf', 
          },
          {
            date: '2021-11-25',
            displayDate: '25 Nov 2021',
            code: 'NAM-MHMK-TL-PA-013-21',
            subject: 'PENGAKTIFAN SEMULA EJEN, PEMINDAHAN SIJIL, PELETAKAN JAWATAN EJEN',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMK-TL-PA-013-21.pdf', 
          },
          {
            date: '2021-11-8',
            displayDate: '8 Nov 2021',
            code: 'NAM-MKA-TL-PA-012-21',
            subject: 'SEKATAN OVERRIDING COMMISSION (OR) BULAN OKTOBER 2021',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MKA-TL-PA-012-21.pdf', 
          },
          {
            date: '2021-10-11',
            displayDate: '11 Oct 2021',
            code: 'MKA-TL-C002-21',
            subject: 'CHIEF ADVISOR PLANNING CONFERENCE (CAPC) 2022',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-C002-21.pdf', 
          },
          {
            date: '2021-10-5',
            displayDate: '5 Oct 2021',
            code: 'NAM-MKA-TL-PA-011-21',
            subject: 'SEKATAN OVERRIDING COMMISSION (OR) BULAN SEPTEMBER 2021',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MKA-TL-PA-011-21.pdf', 
          },
          {
            date: '2021-9-6',
            displayDate: '6 Sept 2021',
            code: 'MKA-TL-PA-010-21',
            subject: 'TLP CAMPAIGN 2.0',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-010-21.pdf', 
          },
          {
            date: '2021-8-11',
            displayDate: '11 Aug 2021',
            code: 'MKA-TL-PA-009-21',
            subject: 'SEKATAN OVERRIDING COMMISSION (OR) BULAN OGOS 2021',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-009-21.pdf', 
          },
          {
            date: '2021-7-6T00:10:00',
            displayDate: '6 July 2021',
            code: 'MKA-TL-PA-007-21',
            subject: 'PENGECUALIAN KHAS "MOC" UNTUK CA BERSTATUS "AGENCY MANAGER (AM)"',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-007-21.pdf', 
          },
          {
            date: '2021-7-6T00:00:00',
            displayDate: '6 July 2021',
            code: 'MKA-TL-PA-008-21',
            subject: '"REWARD IPAD" ISTIMEWA UNTUK CHIEF ADVISOR (CA)',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-008-21.pdf', 
          },
          {
            date: '2021-6-9',
            displayDate: '9 June 2021',
            code: 'MKA-TL-PA-006-21',
            subject: 'SEKATAN OVERRIDING COMMISSION (OR)',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-006-21.pdf', 
          },
          {
            date: '2021-6-9',
            displayDate: '9 June 2021',
            code: 'NAM-MHMT-TL-PA-005-21',
            subject: 'YURAN PENDAFTARAN MTA NEW SALES TALENT (NST)',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMT-TL-PA-005-21.pdf', 
          },
          {
            date: '2021-5-24',
            displayDate: '24 May 2021',
            code: 'NAM-MHMT-OF-004-21',
            subject: 'PERINTAH KAWALAN PERGERAKAN 3.0 (PKP MEI 2021)',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMT-OF-004-21.pdf', 
          },
          {
            date: '2021-5-5',
            displayDate: '5 May 2021',
            code: 'NAM-MHMT-OF-003-21',
            subject: 'CUTI HARI RAYA AIDILFITRI 1442H',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMT-OF-003-21.pdf', 
          },
          {
            date: '2021-5-5',
            displayDate: '5 May 2021',
            code: 'MKA-TL-PA-004-21',
            subject: 'SEKATAN OVERRIDING COMMISSION (OR)',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-004-21.pdf', 
          },
          {
            date: '2021-5-4',
            displayDate: '4 May 2021',
            code: 'MKA-TL-PA-003-21',
            subject: 'KEMPEN "ALL ABOUT TRUST" & PENGAKTIFAN AKAUN "MY ZURICH LIFE @ MYACCOUNT"',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-003-21.pdf', 
          },
          {
            date: '2021-4-9',
            displayDate: '9 April 2021',
            code: 'MKA-TL-PA-002-21',
            subject: 'PENYELENGGARAAN KONTRAK TAHUNAN (MOC) BERMULA TAHUN 2021 DAN PENILAIAN SUKU TAHUNAN',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-002-21.pdf', 
          },
          {
            date: '2021-3-25',
            displayDate: '25 March 2021',
            code: 'MKA-TL-PA-001-21',
            subject: 'MEMO PELAKSANAAN SISTEM PENGURUSAN AGENSI DAN AKTIVITI JUALAN',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/MKA-TL-PA-001-21.pdf', 
          },
          {
            date: '2021-1-12',
            displayDate: '12 Jan 2021',
            code: 'NAM-MHMT-TL-C001-21',
            subject: 'MEMO PERINTAH KAWALAN PERGERAKAN 2.0 (PKP 2021)',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMT-TL-C001-21.pdf', 
          },
        ], 
      },
      { 
        title: '2020',
        list: [
          {
            date: '2020-12-23',
            displayDate: '23 Dec 2020',
            code: 'NAM-MHMT-TL-C003-20',
            subject: 'DECEMBER TO REMEMBER PROMOTION',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMT-TL-C003-20.pdf', 
          },
          {
            date: '2020-12-16',
            displayDate: '16 Dec 2020',
            code: 'NAM-MHMT-TL-C002-20',
            subject: 'CONTEST DECEMBER TO REMEMBER PROMOTION CHIEF ADVISOR WITH SPECIAL CONDITION',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMT-TL-C002-20.pdf', 
          },
          {
            date: '2020-12-8',
            displayDate: '8 Dec 2020',
            code: 'NAM-MHMT-TL-C001-20',
            subject: 'ANNUAL PLANNING CONFERENCE (APC) & MEGA KICK-OFF 2021',
            link: 'https://teraslegacy.com/wp-content/uploads/2022/01/NAM-MHMT-TL-C001-20.pdf', 
          },
        ], 
      },
    ],
      
  }),

  methods: {
    viewInDialog(link, title) {
      this.dialog = true
      this.link = link
      this.title = title
    },

    handleDocRender () {
      //console.log('handleDocRender : ' + args)
      this.isLoading = false
      this.isErrorLoading = false
    },
    handleDocProgress(args) {
      console.log('handleDocProgress : ' + args);
      this.isLoading = true
      this.isErrorLoading = false
    },
    handleLoadingFailed(args) {
      console.log('handleLoadingFailed : ' + args);
      this.isLoading = false
      this.isErrorLoading = true
    },

    closeDialog() {
      this.dialog = false
      this.link = ''
      this.isLoading = true
      this.title = ''
    }
  },
}
</script>